<template>
  <div class="songpagelist">
    <div class="row mb-3" v-for="item in dataList">
      <div class="left float-left text-left">
        <a :href="prefixUrl + item.id + '/' + convertToAlias(item.song)">
          <img class="thumbnail ml-1" :src="item.thumbnail != '' ? item.thumbnail : defaultThumbnail"/>
          <h4 class="song color-text">{{ item.song }}</h4>
          <p class="singer color-text">{{ item.singer }}</p>
          <p class="songcode"><span class="color-text font-weight-bold codesong">Mã: {{ item.code }}</span></p>
        </a>
      </div>

      <div class="right float-right text-right mt-3">
        <!--<a><span class="fa fa-tablet color-text font-size-18 pl-1 pr-1"></span></a>-->
        <a @click="item.RingBackTone != '' ? showModal(downloadAlert.replace('songcode', item.RingBackTone)) : showModal(settings.installRingbacktoneAlert)">
          <span class="fa fa-download color-text font-size-18 pl-1 pr-1"></span>
        </a>
        <a @click="showModal(giftAlert.replace('songcode', item.code))">
          <span class="fa fa-gift color-text font-size-22 pl-1 pr-1"></span>
        </a>
        <a target="_blank"
           :href="shareFacebookUrl"
           class="fb-xfbml-parse-ignore">
          <span class="fa fa-facebook-square color-text font-size-18 pl-1 pr-1"></span></a>
      </div>
    </div>

    <div class="mb-3 mt-3 text-center" v-if="totalRecord==0">
      <p>{{ settings.noSongAlert }}</p>
    </div>

    <pagination-2
      v-if="totalPage > 1"
      :total-pages="totalPage"
      :total="totalRecord"
      :per-page="10"
      :current-page="currentPage"
      @pagechanged="onPageChange"
      :previous-name="previousName"
      :next-name="nextName"
    >
    </pagination-2>
    <div class="mb-5"></div>

    <modal :modal-title="modalTitle" :modal-message="modalMessage"></modal>
  </div>
</template>

<script>
  import Pagination2 from '../../Pagination2'

  export default {
    name: "CategorySongMostView",
    components: {
      'pagination-2': Pagination2
    },
    props: {
      categoryCodeToLastChild: String
    },
    data () {
      return {
        defaultThumbnail: this.settings.defaultThumbnailSong,
        prefixUrl: this.settings.prefixSong,
        modalTitle: "Thông báo",
        modalMessage: "",
        shareFacebookUrl: "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href + "&amp;src=sdkpreparse",
        currentPage: 1,
        totalRecord: 1,
        totalPage: 1,
        previousName: "previousArrow",
        nextName: "nextArrow",
        dataList: [],
        giftAlert: this.settings.giftAlert,
        downloadAlert: this.settings.downloadAlert
      }
    },
    created () {

    },
    methods: {
      getDataList(){
        var dataPost = {
          "orderBy": 2,
          "subCategoryCode": this.categoryCodeToLastChild,
          "pageSize": 5,
          "pageIndex": this.currentPage
        };
        axios.post(api.songListByCategory, dataPost)
          .then(response => {
            this.dataList = response.data.result;
            this.totalRecord = response.data.totalRecord;
            this.totalPage = response.data.totalPage;
          }).catch(error => {
          console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      },
      showModal(message){
        this.modalMessage = message;
        this.modalShow();
      }
    },
    watch: {
      "currentPage": {
        handler: "getDataList",
        immediate: true
      },
      "categoryCodeToLastChild": {
        handler: function (val) {
          this.currentPage = 1;
          this.getDataList();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .songpagelist .left{
    width: 65%
  }
  .songpagelist .right{
    width: 35%;
  }
  .thumbnail{
    float: left;
    margin-right: 5px;
    width: 60px;
    height: 60px;
  }
  .songcode{
    padding-left: 64px;
    position: relative;
    top: -0.8rem;
    margin-bottom: -1rem;
  }
  .codesong{
    background-color: #ececec;
    padding: 0.2rem 0.5rem;
    border-radius: 30px;
  }
  .pagination{
    position: relative;
    top: 2rem;
    margin: 0 auto;
    text-align: center;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/song/wap/CategorySongMostView.vue